var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { Switch, Text, View } from "react-native";
var Controls = /** @class */ (function (_super) {
    __extends(Controls, _super);
    function Controls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Controls.prototype.renderSwitch = function (_a) {
        var _this = this;
        var _b;
        var label = _a.label, value = _a.value, key = _a.key;
        return React.createElement(View, { style: {
                flexDirection: "row",
                padding: 0,
                alignItems: "center",
                justifyContent: "center"
            } },
            React.createElement(Switch, { value: value, style: {
                // transform: [{ scale: 0.5 }]
                }, onValueChange: function (e) {
                    var _a;
                    _this.props.parent.setState((_a = {}, _a[key] = e, _a));
                } }),
            React.createElement(View, { style: { width: 4 } }),
            React.createElement(Text, { style: { color: (_b = this.props.parent.props.textColor) !== null && _b !== void 0 ? _b : "#000", fontSize: 10 } }, label));
    };
    Controls.prototype.render = function () {
        return React.createElement(View, { style: {
                position: "absolute",
                right: 0,
                backgroundColor: "#ffffff66",
                borderRadius: 8,
                flexDirection: "row"
            } },
            this.renderSwitch({ label: "Values", value: this.props.parent.state.showValue, key: "showValue" }),
            this.renderSwitch({ label: "Label", value: this.props.parent.state.showLabel, key: "showLabel" }),
            this.renderSwitch({ label: "Guide", value: this.props.parent.state.showGuide, key: "showGuide" }));
    };
    return Controls;
}(React.Component));
export default Controls;
